<template>
  <div id='comp-app-form-btn' class="button-section">
    <!-- <a href="/compAnnWrite.do" class="btn btn-primary btn-md" @click="showAppForm" title="태그 검색"> -->
    <a href="/compAnnWrite.do" class="btn btn-primary btn-md">
      <i class="ico ico-pen-wt"></i>
      공고 등록
    </a>
  </div>
</template>

<script>
export default {
  name: 'comp-app-form-btn',
  props: [],
  components: {},
  data() {
    return {};
  },
  watch: {},
  methods: {
    /**
     * 공고 등록 버튼 클릭 시 부모 컴포넌트에 이벤트 전달
     */
    showAppForm() {
      this.$emit('showAppForm');
    },
  },
  mounted() {},
};
</script>



// WEBPACK FOOTER //
// CompAppFormBtn.vue?3a75bf94